/* eslint-disable */

import { Component } from 'react';
import { isTrue } from '../../../../helpers/isTrue';
import ActivateAllDomains from '../../../ActivateDomain/AllDomains';
import ActivateDomain from '../../../ActivateDomain/Domain';
import DataBackfill from '../../../../modules/DataBackfill';

class Domains extends Component {
    constructor() {
        super();

        this.domains = window.settings_domains;
        this.is_viewer = !window.is_not_viewer;
        this.active_domains = window.active_domains ?? [];
        this.domains_with_permission_error = window.domains_with_permission_error ?? [];

        this.is_superuser = isTrue(window.is_superuser);
    }

    render() {
        return (
            <div className="settings-card settings-domains">
                <div className="settings-domains-header">
                    <div>
                        <div className="d-flex">
                            Domains
                            <div className="settings-domains-tag">
                                {this.props.active_domains_count} out of{' '}
                                {this.props.available_domains_count}
                            </div>
                        </div>
                        {this.is_viewer && (
                            <div className="settings-domains-subtitle">
                                Only main user can activate/deactivate domain
                            </div>
                        )}
                        {this.props.active && this.props.available_domains_count > 1 && (
                            <>
                                <div className="settings-domains-subtitle">
                                    {' '}
                                    Only 1 domain can be activated during free trial, You will be
                                    able to activate other domains once trial ends.
                                </div>
                                {!this.props.active_domains_exists && (
                                    <div className="settings-domains-subtitle">
                                        Please select 1 domain to activate during the trial period.
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                    <div>
                        {!isTrue(this.props.is_deactivated) && (
                            <>
                                {!isTrue(this.props.active) &&
                                    this.props.available_domains_count > 1 && (
                                        <ActivateAllDomains
                                            available_domains_count={
                                                this.props.available_domains_count
                                            }
                                        />
                                    )}
                                <a
                                    href="/domains/link"
                                    className="button button-filled button-primary"
                                >
                                    Add a Domain
                                </a>
                            </>
                        )}{' '}
                    </div>
                </div>
                <div className="settings-domains-body">
                    {this.domains?.length > 0 &&
                        this.domains?.map((domain) => (
                            <div key={domain.id}>
                                <div className="settings-domains-body-item">
                                    {!isTrue(this.props.is_deactivated) && (
                                        <ActivateDomain
                                            domain_pk={domain.pk}
                                            active_domains={this.props.active_domains}
                                            active_domains_count={this.props.active_domains_count}
                                            active_domain={domain.active}
                                            available_domains_count={
                                                this.props.available_domains_count
                                            }
                                            domain_url={domain.url}
                                            is_viewer={this.is_viewer}
                                        />
                                    )}
                                    <div>
                                        <div className="settings-domains-body-item-text">
                                            {domain.url}
                                            {(domain.active ||
                                                (isTrue(this.props.is_deactivated) &&
                                                    this.active_domains.includes(domain.id))) && (
                                                <a href={`/domains/${domain.pk}/`}>View Report</a>
                                            )}
                                        </div>
                                        {this.is_superuser && (
                                            <div className="dataBackfill-container">
                                                <DataBackfill domain={domain.url} />
                                                <div style={{ fontSize: '9px', color: '#888' }}>
                                                    <strong>Domain:</strong> {domain.url}{' '}
                                                    <strong>Account: </strong> {domain.account}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <div>
                                        {this.is_superuser && (
                                            <a
                                                href={`/domains/${domain.pk}/update?next=/settings/`}
                                                title="Refresh (30 Days)"
                                            >
                                                {' '}
                                                <i className="icon-Frame-converted"></i>
                                            </a>
                                        )}
                                    </div>
                                </div>
                                {this.domains_with_permission_error.includes(domain.url) && (
                                    <div className="permissions-errors-message">
                                        The site {domain.url} is no longer connected, please select
                                        a google linked account from the list above and reselect the
                                        same site or select a different site. if you can't still
                                        resolve the error, please contact us info@gddash.com
                                    </div>
                                )}
                            </div>
                        ))}
                </div>
            </div>
        );
    }
}

export default Domains;
